module.exports = __webpack_public_path__ + "img/logo-koprol.ee37adf7.png";